"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsteriskAnnounceHoldtimeEnum = void 0;
var AsteriskAnnounceHoldtimeEnum;
(function (AsteriskAnnounceHoldtimeEnum) {
    AsteriskAnnounceHoldtimeEnum["YES"] = "yes";
    AsteriskAnnounceHoldtimeEnum["NO"] = "no";
    AsteriskAnnounceHoldtimeEnum["ONCE"] = "once";
})(AsteriskAnnounceHoldtimeEnum = exports.AsteriskAnnounceHoldtimeEnum || (exports.AsteriskAnnounceHoldtimeEnum = {}));
